import { AnonymousUserLDContext, UserLDContext } from '../LDContext.types';

export const getAnonymousUserLDContext = (): {
  user: AnonymousUserLDContext;
} => ({
  user: {
    // Generating anonymous users
    // https://launchdarkly.com/docs/sdk/features/anonymous#javascript
    // Setting this massively increases our MAU and billing from Launch Darkly...
    // kind: 'user',
    key: 'user',
    anonymous: true,
  } as AnonymousUserLDContext,
});

export const getUserLDContext = (uuid: string, email?: string) => ({
  user: {
    kind: 'user',
    key: uuid,
    uuid,
    email,
  } as UserLDContext,
});
